import { createGeneralPageEventsAndComponents } from "../technical/page-general";
import { createProductGrid } from "../molecules/product-grid";
import {
	expressQuerySelector,
	expressQuerySelectorAll,
	expressRemoveClass,
	getParentWithClassName,
} from "../../common/html";
import { createWishListButton } from "../technical/wishlist";
import { getWishlistItems } from "../../services/wishlist-service";

window.addEventListener("DOMContentLoaded", async () => {
	createGeneralPageEventsAndComponents();

	window.showMores = [];
	// load the wishlistItems
	window.wishlist = await getWishlistItems();
	const productGridEl = expressQuerySelector<HTMLElement>(document, ".technical-product-grid");
	const mobileFilterButtonEl = expressQuerySelector<HTMLElement>(
		productGridEl,
		".technical-filters-mobile-button",
		false,
	);
	const productContentEl = expressQuerySelector<HTMLElement>(productGridEl, ".m-product-grid__content", true);
	const wishListButtonEls = expressQuerySelectorAll<HTMLButtonElement>(productContentEl, ".technical-wishlist-button");
	const filterContainerEl = expressQuerySelector<HTMLElement>(document, ".technical-filters-container", false);

	const productGrid = createProductGrid(productGridEl, {});

	if (wishListButtonEls.length > 0) {
		wishListButtonEls.forEach((el) => {
			const onDisLike = () => {
				const tile = getParentWithClassName(el, "m-product");
				if (tile) tile.remove();

				// Hide filters if only tiles of one type left + show empty state if no tiles left
				const wishlistTiles = expressQuerySelectorAll<HTMLElement>(productGridEl, ".m-product");
				const productWishlistTiles = wishlistTiles.filter(
					(c) => c && (c.dataset.tagid || "").toLowerCase() === "product",
				);
				const designOnProductWishlistTiles = wishlistTiles.filter(
					(c) => c && (c.dataset.tagid || "").toLowerCase() === "designonproduct",
				);
				if ((productWishlistTiles.length === 0 || designOnProductWishlistTiles.length === 0) && filterContainerEl) {
					filterContainerEl.remove();
					mobileFilterButtonEl && mobileFilterButtonEl.remove();
					productGrid.hideEmptyStateResetButton();
					expressRemoveClass(productGridEl, "m-product-grid--filters");
				}
				if (wishlistTiles.length === 0) {
					productGrid.showEmptyState();
				}
				productGrid.calculateHackFor2TilesOnLastLine(productGridEl);
			};
			createWishListButton(el, { onDisLike });
		});
	}
});
